<template>
  <Modal
    id="invoice"
    v-model:is-open="isActive"
    size="is-medium"
    header="Registrar pago de factura"
    button-label="Agregar"
    :save-disabled="saveDisabled"
    :is-disabled="loading"
    @save="onSubmit"
    @cancel="closeModal"
  >
    <form ref="form">
      <div class="columns mb-1">
        <div class="column">
          <Field v-model="billData.folio" class="mb-0" label="Referencia del pago:" disabled />
        </div>
        <Field
          v-model="billData.charge"
          class="column mb-0 has-addons-left"
          label="Monto:"
          disabled
        >
          <template #addonsLeft>
            <div class="monto-addon has-addons-right">$</div>
          </template>
        </Field>
      </div>
      <div class="columns mb-1">
        <Field
          v-model="billData.paymentFolio"
          class="column mb-0"
          maxlength="15"
          text-transform="upper"
          placeholder="Ingresar folio"
          label="Folio:"
          required
          :disabled="loading"
        />
        <div class="column">
          <DatePicker
            v-model="billData.paymentDate"
            v-bind="startPaydateAttrs"
            response-format="DD/MM/YYYY"
            class="paysheet-date"
            label="Fecha de pago:"
            placeholder="Seleccionar fecha"
            :max-date="maxDate"
            append-to-body
            required
            :disabled="loading"
          />
        </div>
      </div>
      <Field
        v-model="billData.description"
        label="Descripción del pago:"
        type="textarea"
        maxlength="100"
        placeholder="Agregue aquí una descripción del pago..."
        :disabled="loading"
      />
      <p class="ml-auto counter-field mt-1">{{ descriptionLenght }}</p>
    </form>
  </Modal>
</template>
<script setup>
// Imports
import { computed, defineModel, reactive, ref, watch } from 'vue';
import { Modal, Field } from '@/components';
import DatePicker from '../DatePicker.vue';
import moment from 'moment';

// Component Options

// Props and Emits
const props = defineProps({
  clientId: { type: String, default: '' },
  data: { type: Object, default: () => {} },
  loading: { type: Boolean, default: false },
});
const emit = defineEmits(['payInvoice', 'update:active', 'closeModal']);
const isActive = defineModel('active', { type: Boolean, default: false });

const billData = reactive({
  charge: '',
  folio: '',
  description: '',
  paymentFolio: '',
  paymentDate: '',
  billUuid: '',
});
const maxDate = ref(new Date());

// Composition API Helpers
// Reactive Variables
// Computed Properties
const saveDisabled = computed(() => {
  return !billData.paymentFolio && !billData.paymentDate.length;
});

const descriptionLenght = computed(() => `${billData.description?.length ?? 0} / 100`);

// Watchers
watch(
  [() => props.data, isActive],
  ([newData, isOpen]) => {
    if (!newData || !isOpen) return;
    if (newData.charge !== undefined) billData.charge = newData.charge;
    if (newData.folio !== undefined) billData.folio = newData.folio;
    if (newData.bill_uuid !== undefined) billData.billUuid = newData.bill_uuid;
  },
  { immediate: true, deep: false },
);

// Lifecycle Hooks

// Methods
const onSubmit = () => {
  const dueDate = moment(billData.paymentDate).format('YYYY-MM-DD HH:mm:ss');
  const payload = {
    charge: Number(billData.charge),
    description: billData.description,
    folio: billData.paymentFolio,
    due_date: dueDate,
    related_uuid: billData.billUuid,
  };
  emit('payInvoice', payload);
  resetForm();
};

const closeModal = () => {
  emit('update:active', false);
  resetForm();
};

const resetForm = () => {
  billData.charge = '';
  billData.folio = '';
  billData.description = '';
  billData.paymentFolio = '';
  billData.paymentDate = '';
  billData.billUuid = '';
};
</script>

<style lang="sass" scoped>
.invoice
  :deep(.card)
    .card-content
      overflow: visible
      @include until($bp-sm)
        max-height: 45vh
        overflow: scroll
      .monto-addon
        border-radius: 5px 0px 0px 5px
        background: $grey-light
        border: 1px solid $grey-light-2
        padding: 5px 10px
        color: $grey-info
.paysheet-date
  :deep(.datepicker)
    width: 100%
  :deep(.datepicker .has-icons-left .input)
    padding-left: 35px
</style>
